import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { useCopyToClipboard } from '~/hooks/useCopyToClipboard'
import { useLogEvent } from '~/hooks/useLogEvent'
import { compile } from '~/routes/paths'

import { type DocumentImage } from '../hooks/useFetchDocumentImages'

export type ShareButtonProps = {
  documentImage: DocumentImage
}

export const ShareButton = ({ documentImage }: ShareButtonProps) => {
  const { t } = useTranslation()
  const logEvent = useLogEvent()
  const copyToClipboard = useCopyToClipboard()
  const handleClick = React.useCallback<EH<StyledButtonProps, 'onClick'>>(
    (event) => {
      event.stopPropagation()

      const sharedUrl = `${window.location.origin}${compile('restore', {
        key: documentImage.restoreKey,
      })}`
      copyToClipboard(sharedUrl, {
        notificationText: t('documentimage_title_url_copied_to_clipboard', {
          documentImage,
        }),
      })
      logEvent('Share table and graph')
    },
    [copyToClipboard, documentImage, logEvent, t],
  )

  return (
    <StyledButton fillMode="outline" icon="share" onClick={handleClick}>
      {t('share_2')}
    </StyledButton>
  )
}
